export default function loadAccessListByUser() {
  return '{accessListByUser{loggedUser{id, name, login, clientId, clientName, selectedTermId }}}';
}
